import { IAppLanguage } from '../_models/appSetting.model';

export const appLanguage: IAppLanguage[] = [
    {
        langName: 'English',
        langCode: 'en',
        translation: 'English',
        isActive: true,
    },
    {
        langName: 'Hindi',
        langCode: 'hi',
        translation: 'हिंदी',
        isActive: true,
    },
    {
        langName: 'Tamil',
        langCode: 'ta',
        translation: 'தமிழ்',
        isActive: true,
    },
    {
        langName: 'Urdu',
        langCode: 'ur',
        translation: 'اردو',
        isActive: true,
    },
    {
        langName: 'Kannada',
        langCode: 'kn',
        translation: 'ಕನ್ನಡ',
        isActive: true,
    },
    {
        langName: 'Marathi',
        langCode: 'mr',
        translation: 'मराठी',
        isActive: true,
    },
    {
        langName: 'Punjabi',
        langCode: 'pa',
        translation: 'ਪੰਜਾਬੀ',
        isActive: true,
    },
    {
        langName: 'Bengali',
        langCode: 'bn',
        translation: 'বাংলা',
        isActive: true,
    },
    {
        langName: 'Telugu',
        langCode: 'te',
        translation: 'తెలుగు',
        isActive: true,
    },
    {
        langName: 'Sindhi',
        langCode: 'sd',
        translation: 'سنڌي',
        isActive: true,
    },
    {
        langName: 'Gujrati',
        langCode: 'gu',
        translation: 'ગુજરાતી',
        isActive: true,
    },
    {
        langName: 'Sansakrit',
        langCode: 'sa',
        translation: 'संस्कृतम्',
        isActive: true,
    },
    {
        langName: 'Odia',
        langCode: 'or',
        translation: 'ଓଡିଆ',
        isActive: true,
    },
    {
        langName: 'Assamese',
        langCode: 'as',
        translation: 'অসমীয়া',
        isActive: true,
    },
    {
        langName: 'Bhojpuri',
        langCode: 'bho',
        translation: 'भोजपुरी',
        isActive: true,
    },
    {
        langName: 'Awadhi',
        langCode: 'awa',
        translation: 'अवधी',
        isActive: true,
    },
    {
        langName: 'Malayalam',
        langCode: 'ml',
        translation: 'മലയാളം',
        isActive: true,
    },
    {
        langName: 'Nepali',
        langCode: 'ne',
        translation: 'Nepali',
        isActive: true,
    },
];

export const defaultLang: IAppLanguage = appLanguage[0];

export const theme = {
    LIGHT: 'light',
    DARK: 'dark',
};

export const defaultTheme: string = theme.LIGHT;

export const defaultFontSize = 12;

export const defaultDateFormat = 'dd-MM-YYYY';

export enum USER_GEO_LEVEL {
    STATE_LEVEL = 1,
    DISTRICT_LEVEL = 2,
    BLOCK_LEVEL = 3,
    GRAM_PANCHAYAT_LEVEL = 4,
    VILLAGE_LEVEL = 5,
    CLF_LEVEL = 6,
}
